<app-core-popup
  [header]="firstly?'common.last_password_update_info':'common.new_user_password_update_info' | translate "
  [dialogStyle]="{width: '45rem' }"
  [saveText]="'common.update' | translate"
  (chooseOn)="updatePassword()"
  [saveButtonDisable]="!(passwordForm.oldPassword && passwordForm.newPassword && passwordForm.newPasswordConfirm)"
  [hideCancel]="true"
  #popup
>
  <div *ngIf="openPopup">
    <div class="row">
      <div class="col-sm-12 d-flex align-items-center mb-2">
        <label for="oldPassword" class="col-4 form-label">{{
            "settings.user-settings.old-password" | translate
          }}</label>
        <div class="col-8 position-relative">
          <input
            [type]="passwordForm.isHover1 ? 'text' : 'password'"
            class="form-control pe-5"
            [(ngModel)]="passwordForm.oldPassword"
            id="oldPassword"
            [placeholder]="
                  'settings.user-settings.old-password' | translate
                "
          />
          <i
            class="fa fa-eye position-absolute"
            style="
                  top: 50%;
                  right: 10px;
                  transform: translateY(-50%);
                  cursor: pointer;
                "
            (mouseover)="passwordForm.isHover1 = true"
            (mouseout)="passwordForm.isHover1 = false"
            (focus)="passwordForm.isHover1 = true"
            (blur)="passwordForm.isHover1 = false"
          ></i>
        </div>
      </div>
      <div class="col-sm-12 d-flex align-items-center mb-2">
        <label for="newPassword" class="col-4 form-label">
          {{ "settings.user-settings.new-password" | translate }}
        </label>
        <div class="col-8 position-relative">
          <input
            [type]="passwordForm.isHover2 ? 'text' : 'password'"
            class="form-control pe-5"
            [(ngModel)]="passwordForm.newPassword"
            id="newPassword"
            [placeholder]="
                  'settings.user-settings.new-password' | translate
                "
          />
          <i
            class="fa fa-eye position-absolute"
            style="
                  top: 50%;
                  right: 10px;
                  transform: translateY(-50%);
                  cursor: pointer;
                "
            (mouseover)="passwordForm.isHover2 = true"
            (mouseout)="passwordForm.isHover2 = false"
            (focus)="passwordForm.isHover2 = true"
            (blur)="passwordForm.isHover2 = false"
          ></i>
        </div>
      </div>
      <div class="col-sm-12 d-flex align-items-center mb-2">
        <label for="newPasswordConfirm" class="col-4 form-label">{{
            "settings.user-settings.new-password-confirm" | translate
          }}</label>
        <div class="col-8 position-relative">
          <input
            [type]="passwordForm.isHover3 ? 'text' : 'password'"
            class="form-control pe-5"
            [(ngModel)]="passwordForm.newPasswordConfirm"
            id="newPasswordConfirm"
            [placeholder]="
                  'settings.user-settings.new-password-confirm' | translate
                "
          />
          <i
            class="fa fa-eye position-absolute"
            style="
                  top: 50%;
                  right: 10px;
                  transform: translateY(-50%);
                  cursor: pointer;
                "
            (mouseover)="passwordForm.isHover3 = true"
            (mouseout)="passwordForm.isHover3 = false"
            (focus)="passwordForm.isHover3 = true"
            (blur)="passwordForm.isHover3 = false"
          ></i>
        </div>
      </div>
    </div>
  </div>
</app-core-popup>

<app-loading [loading]="loading" [fullScreen]="true"></app-loading>
